module.exports = __webpack_public_path__ + "media/images/snek2-a69a29a917b046ca68dad4b55ef03c30.jpeg";